<template>
  <section
    role="region"
    class="partner-how-works-section"
    id="how-it-works"
    ref="partnerHowWorks"
  >
    <div class="steps">
      <TheSecondHead
        v-show="showSteps"
        class="default-card understand"
        :class="makeFade ? 'show' : ''"
        chipText="Passo a passo"
        titleText="Entenda como nosso serviço funciona"
      />

      <TheCard
        elevation="0"
        :style="`transition-duration: ${item.id * 0.7}s !important`"
        v-show="showSteps"
        :class="makeFade ? 'show' : ''"
        v-for="item in stepsArray"
        :key="item.id"
        :mediaSrc="`partners/${creditor.alias}/${item.mediaSrc}.png`"
        :imageAlt="item.title"
        :paragraphText="item.text"
      >
        <template #out-of-box>
          <div class="step-counter">
            <h1 class="number">{{ item.id }}</h1>
          </div>
        </template>
      </TheCard>
    </div>
  </section>
</template>

<script setup lang="ts">
import { usePartnerHowWorks } from '@/stores/partners/partnerHowWorks';

const store = usePartnerHowWorks();
const stepsArray = store.getSteps;

defineProps<{
  creditor: CreditorProfile;
}>();

const partnerHowWorks = ref<any>(null);
const makeFade = ref<Boolean>(false);
const partnerhowWorksWatcher = () => {
  var section = partnerHowWorks.value;

  if (window.scrollY + section.offsetHeight >= section.offsetHeight) {
    setTimeout(() => {
      makeFade.value = true;
    }, 100);
    window.removeEventListener("scroll", partnerhowWorksWatcher);
  }
};

const showSteps = ref<Boolean>(false);
onMounted(() => {
  showSteps.value = true;
  window.addEventListener("scroll", partnerhowWorksWatcher, { passive: true });
  partnerhowWorksWatcher();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", partnerhowWorksWatcher);
});
</script>

<style lang="scss">
.partner-how-works-section {
  .default-card {
    opacity: 0;
    -webkit-transform: translateY(113px);
    transform: translateY(113px);
  }

  .show {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
    opacity: 1;

    -webkit-transition: all 0.6s ease;
    -moz-transition: all 0.6s ease;
    -o-transition: all 0.6s ease;
    transition: all 0.6s ease;
  }
}
</style>
